import styled from 'styled-components'
import { Body as CLBody } from 'syf-component-library/ui/typography'
import query from 'mediaQueries'

export const List = styled.ul<{ type?: string }>`
  list-style-type: ${({ type }): string => type || 'auto'};
  padding-left: 29px;
  li {
    line-height: 1.5;
  }
`

export const Body = styled(CLBody)`
  font-size: 14px;
`
const gridStyle = `
  display: grid;
  row-gap: 0.27em;
  `

export const CustomerServiceHours = styled.ul`
  ${gridStyle}
  grid-template-columns: 10em 1fr;
`

export const HideReplacement = styled.span`
  @media ${query.lessThanSmall} {
    display: none;
  }
`
